import React, { useState } from 'react';

const subjectPdfLinks = [
  { label: "英語", url: "https://toitumosi.jp/pdf/ecH8CdL5e.pdf?20260119" },
  { label: "数学", url: "https://toitumosi.jp/pdf/suN2sA9mTY.pdf??20260119" },
  { label: "国語", url: "https://toitumosi.jp/pdf/kVi5Z7XEj.pdf??20260119" },
  { label: "理科", url: "https://toitumosi.jp/pdf/rGu9hQebX.pdf?20260119" },
  { label: "社会", url: "https://toitumosi.jp/pdf/sT3q8cCEr.pdf?20260119" },
];

export default function KaitouAndHensachi() {
  const [showRankGuide, setShowRankGuide] = useState(false);
  return (
    <div className="container mt-4">
      <div className="row row-cols-1 row-cols-md-2 g-4 mb-5">
        {/* 解答・解説カード */}
        <div className="col">
          <div className="card shadow-lg border-0 border-top border-5 border-primary rounded-4 h-100 ">
            <div className="card-body d-flex flex-column align-items-center p-4 p-md-5 text-center">
              <h3 style={{ color: 'royalblue' }} className="card-title h4 fw-bold mb-1">解答・解説</h3>

              <div className="d-flex flex-wrap justify-content-center gap-2 my-4">
                {subjectPdfLinks.map((subject) => (
                  <a
                    key={subject.label}
                    href={subject.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn text-white py-2 px-4 rounded-3 fw-bold"
                    style={{ background: 'royalblue' }}
                  >
                    {subject.label}
                  </a>
                ))}
              </div>

              <div className="alert alert-warning d-flex align-items-start p-3 w-100 text-start">
                <div>
                  <p className="mb-0 small">
                    <strong className="fw-bold">統一模試の解答解説は、受験回の予約受付期間までの期間限定公開となります。保存したい方は、ダウンロードまたはスクリーンショット等で保存してください。</strong><br />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 偏差値による判定基準カード */}
        <div className="col">
          <div className="card shadow-lg border-0 border-top border-5 border-success rounded-4 h-100">
            <div className="card-body d-flex flex-column align-items-center p-4 p-md-5 text-center">
              <h3 style={{ color: '#009d80' }} className="card-title h4 fw-bold mb-1">偏差値判定基準</h3>

              <a
                href="https://toitumosi.jp/img/kai5.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button style={{ background: '#009d80' }} className="mt-3 btn w-100 text-white py-3 rounded-3 fw-bold d-flex align-items-center justify-content-center gap-2 mb-4 fs-5">
                  偏差値判定基準(PDF)
                </button>
              </a>

              {/* <button style={{ background: '#009d80' }} className="mt-3 btn w-100 text-white py-3 rounded-3 fw-bold d-flex align-items-center justify-content-center gap-2 mb-4 fs-5">
              ※準備中
              </button> */}


              <button
                onClick={() => setShowRankGuide(!showRankGuide)}
                className="btn btn-link text-success text-decoration-none fw-medium d-flex align-items-center gap-1 mb-2"
              >
                階層分布表・WEB判定登録について
              </button>

              {showRankGuide && (
                <div className="card card-body bg-light border-light p-3 w-100 small text-secondary text-start">
                  <p className="fw-bold text-success mb-1">志望校別偏差値による判定基準・階層分布表について</p>
                  <p className="mb-3">HPトップ　→　個人成績表の見方　→　WEB判定登録をしていただけますと閲覧することができます。</p>
                  <p className="fw-bold text-success mb-1" style={{ fontSize: '0.75rem' }}>WEB判定登録について</p>
                  <p className="mb-1">初めて受験した答案用紙が郵送された後に整理番号・受験番号から登録できます。</p>
                  <p className="mb-1">※統一模試を受験された方のみWEB判定をご利用できます。</p>
                  <p className="mb-1">（例：第1回・第4回・第5回を受験するとその受験した回の成績を見る事が出来ます）</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
